import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'react-jss'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import compose from '@shopify/react-compose'
import { Ripple } from '@rmwc/ripple'

import '@material/ripple/dist/mdc.ripple.css'
import './ripple.css'

import buttonStyles from './button-style'

const themedRipple = (themeName, children) => {
  return themeName === 'dark' ? children : <Ripple>{children}</Ripple>
}

const Button = props => {
  const themeName = props.forceTheme || props.theme.theme || 'default'
  const classes = buttonStyles(props.theme)
  const buttonProps = {
    className: classNames(
      'ripple-icon-component',
      classes.button,
      props.className,
      props.classType ? classes[props.classType] : null,
      classes[`${themeName}Theme`],
      props.isLoading ? classes.isLoading : null,
    ),
    onClick: props.onClick,
    disabled: props.disabled,
  }

  const buttonContent = () =>
    <Fragment>
      {props.icon && !props.isLoading && <span className={classNames('fal', `fa-${props.icon}`, classes.icon, props.iconClassName)} />}
      {props.isLoading &&
        <Fragment>
          <span className={classNames('fal', 'fa-spinner-third', classes.icon, classes.invisibleIcon)} />
          <span className={classNames('fal', 'fa-spinner-third', 'fa-spin-1500', classes.icon, classes.spinningIcon)} />
        </Fragment>
      }
      {props.children}
    </Fragment>

  if (props.to) {
    return (
      themedRipple(themeName, <Link to={props.to} {...buttonProps}>{buttonContent()}</Link>)
    )
  }

  if (props.href) {
    return (
      themedRipple(themeName, <a href={props.href} {...buttonProps}>{buttonContent()}</a>)
    )
  }

  return themedRipple(themeName,
    <button type={props.type} {...buttonProps}>
      {buttonContent()}
    </button>
  )
}

Button.propTypes = {
  type: PropTypes.string,
  classType: PropTypes.string,
  className: PropTypes.string,
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  children: PropTypes.node.isRequired,
  theme: PropTypes.object.isRequired,
  forceTheme: PropTypes.string, // allows to have default button on some elements within dark theme for example
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  iconClassName: PropTypes.string,
  isLoading: PropTypes.bool,
}

Button.defaultProps = {
  type: 'button',
  disabled: false,
  isLoading: false,
}

export default compose(
  withTheme,
)(Button)
